






















import { Component, Vue, Prop } from 'vue-property-decorator';
import SelectUser from '@/components/selectUser.vue';
import { teamManage } from '../team';

type IUserInfo = IUser.IResponse.IUserDetailInfo;

@Component({
  components: {
    SelectUser,
  },
})
export default class EditTeams extends Vue {
  @Prop({required: true}) private type!: 'add' | 'del';
  private teamOwner: string = '';
  private mode = 'multiple';
  private loading = false;
  private selectedList: string[] = [];
  private removedList: string[] = [];
  private currentMembers: IUserInfo[] = [];
  private created() {
    this.resetEdit();
  }
  // 获取当前的MemberIds
  get currentMemberIds() {
    return this.currentMembers.map((member) => member.id);
  }
  // 处理选项改变
  private handleChange(value: string[]) {
    if (this.mode === 'multiple') {
      this.selectedList = value;
    }
  }
  // 重置编辑数据
  private resetEdit() {
    this.selectedList = [];
    this.removedList = [];
    const members = teamManage.editData.teamInfo?.members || [];
    this.teamOwner = teamManage.editData.teamInfo?.leader || '';
    this.currentMembers = [...members];
  }
  // 删除团队成员
  private removeCurrentMembers(memberId: string) {
    const newcurrentTeams = this.currentMembers.filter((member) => member.id !== memberId);
    this.currentMembers = newcurrentTeams;
    this.removedList.push(memberId);
  }
  private submitAddMembers() {
    if (this.selectedList.length <= 0) {
      this.$emit('ok');
      return;
    }
    this.loading = true;
    teamManage.requestAddMembers(this.selectedList).then((res) => {
      this.$message.success(res);
      this.loading = false;
      this.$emit('ok');
    }).catch((err) => {
      this.loading = false;
      this.$message.warning(err);
    });
  }
  private submitDelMembers() {
    if (this.removedList.length <= 0) {
      this.$emit('ok');
      return;
    }
    this.loading = true;
    teamManage.requestDeleteMembers(this.removedList).then((res) => {
      this.$message.success(res);
      this.loading = false;
      this.$emit('ok');
    }).catch((err) => {
      this.loading = false;
      this.$message.warning(err);
    });
  }
}
